import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import "./JobAssignments.css";

export default function AssignTeamModal({
  open,
  teamOptions,
  selectedCount,
  onApply,
  onClose,
}) {
  const [teamUuid, setTeamUuid] = useState("");

  useEffect(() => {
    if (open) setTeamUuid("");
  }, [open]);

  if (!open) return null;

  return (
    <div className="jfm-overlay" onClick={onClose}>
      <div
        className="jfm-container job-assignments__modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="jfm-header">
          <span className="jfm-title">Assign Team to Selection</span>
          <button className="jfm-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="jfm-body">
          <p className="job-assignments__modal-prompt">
            Assign an approval team to {selectedCount} selected job
            {selectedCount === 1 ? "" : "s"}:
          </p>
          <select
            className="job-assignments__team-select"
            value={teamUuid}
            onChange={(e) => setTeamUuid(e.target.value)}
          >
            <option value="">— None —</option>
            {teamOptions.map((team) => (
              <option key={team.uuid} value={team.uuid}>
                {team.name}
              </option>
            ))}
          </select>
        </div>

        <div className="jfm-footer">
          <div />
          <div className="jfm-footer-actions">
            <button className="jfm-cancel" onClick={onClose}>
              Cancel
            </button>
            <button className="jfm-save" onClick={() => onApply(teamUuid)}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
